import { takeLatest } from 'redux-saga/effects'
import { CONFIRM_DELETE_WHITELABEL } from 'app/redux-base/actions/deleteWL'
import confirmDeleteWL from './confirmDeleteWL'

export default function* watchConfirmDeleteWL() {
  yield takeLatest(CONFIRM_DELETE_WHITELABEL, confirmDeleteWL)
}
